<template>
  <BaseSection is-wide>
    <template #header>
      <BaseTitle
        tag="h1"
        size="xl"
        is-medium
        data-animation="fadeInBottom"
        data-animation-delay="100"
        text="Посмотрите, как&nbsp;ответили<br> другие участники курса:"
      />
    </template>
    <template #content>
      <div v-if="reviews.length" class="section__reviews">
        <BaseReview
          v-for="(review, i) in reviews"
          :key="`review_${i}`"
          v-bind="review"
          class="section__review"
          data-animation="fadeInBottom"
          :data-animation-delay="300 + (i * 150)"
        />
      </div>
      <BaseText
        v-else
        size="s"
        data-animation="fadeInBottom"
        data-animation-delay="300"
      >
        Отзывов пока нет
      </BaseText>
    </template>
  </BaseSection>
</template>

<script>
import { mapState } from 'vuex';

import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseReview from '@/components/BaseReview.vue';

export default {
  name: 'ReviewsPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseText,
    BaseReview,
  },
  computed: {
    ...mapState(['reviews']),
  },
};
</script>
